module.exports = __webpack_public_path__ + "static/img/case-null.83ef312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-null.png
// module id = Jx82
// module chunks = 4